<template>
  <div class="">
    <v-menu
      min-width="280"
      open-on-hover
      :close-on-content-click="false"
      allow-overflow
      close-delay="60"
      h-100
      ma-0
      pa-0
      :content-class="contentClass"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="w-100" v-bind="attrs" v-on="on">
          <inline-svg
            class="menu-svg"
            :class="{
              'custom-opacity':
                item.name !== $store.getters.getPreviousSelectedMenu,
            }"
            :src="item.svg"
          />
        </div>
      </template>
      <v-card class="elevation-0 h-100 poppins">
        <v-card-text
          style="color: black; font-weight: bold; line-height: 1.4"
          class="h3 uppercase pt-8 pe-0 text-black text-bold mb-0"
          :class="{ 'text-start ps-2': $vuetify.rtl }"
        >
          {{ $t(item.title) }}
        </v-card-text>

        <v-card-text class="ma-0 pa-0 poppins">
          <v-list v-if="item.type === 'default'">
            <template v-for="(val, index) in item.entities">
              <!--              <v-list-item :key="index" v-if="!val.hasOwnProperty('items')">-->
              <v-list-item
                :id="'menu-item-' + val.title"
                :key="index"
                :class="{ 'bg-hover-light-info': isAvailableForUser(val) }"
              >
                <div class="position-relative">
                  <router-link
                    :to="isAvailableForUser(val) && { name: val.name }"
                  >
                    <span
                      class="ma-0 pa-0 font-size-h5 font-weight-bolder uppercase poppins"
                      :class="{
                        'text-start ps-2': $vuetify.rtl,
                        'text-dark-50 text-hover-dark': isAvailableForUser(val),
                        'text-dark-25': !isAvailableForUser(val),
                      }"
                    >
                      <!--  plus nav item for unsubscribed users                  style="color: #c5caec !important;"-->
                      {{ $t(val.title) }}

                      <inline-svg
                        v-if="val.premium && isClient"
                        class="position-absolute"
                        style="width: 18px; top: -10px"
                        :src="
                          isAvailableForUser(val)
                            ? '/img/plus/IQ-Plus-star_purple.svg'
                            : '/img/plus/IQ-Core-disabled.svg'
                        "
                      />
                    </span>

                    <!--                    <inline-svg-->
                    <!--                      class="position-absolute purple-plus-star"-->
                    <!--                      style="width: 16px; top: -6px; right: -14px"-->
                    <!--                      src="/img/plus/plus_star.svg"-->
                    <!--                    />-->
                  </router-link>
                </div>
                <b-tooltip
                  v-if="!isAvailableForUser(val)"
                  :target="'menu-item-' + val.title"
                  placement="left"
                  trigger="hover"
                  variant="dark"
                  custom-class="plus-tooltip"
                  boundary="viewport"
                >
                  <div class="tooltip-content">
                    <div class="text-content">
                      <p class="mb-3">
                        <span v-html="$t('exclusive_to_iq_plus')"></span>
                        <!--                        Unlock it to-->
                        <!--                        streamline your returns process with just one click.-->
                      </p>
                    </div>
                    <!-- <button @click="onPressUpgrade" class="upgrade-button">
                      Upgrade to Plus
                    </button> -->
                  </div>
                </b-tooltip>
              </v-list-item>

              <!--   No need for default type, cos it is for submenu one and that's in below    -->
              <!--              <v-list-group :key="index" no-action class="px-0" v-else>-->
              <!--                <template v-slot:activator>-->
              <!--                  <v-list-item-content>-->
              <!--                    <v-list-item-title-->
              <!--                      v-text="$t(val.title)"-->
              <!--                      class="font-size-h5 font-weight-bolder text-dark-50 uppercase poppins"-->
              <!--                      :class="{ 'text-start ps-2': $vuetify.rtl }"-->
              <!--                    />-->
              <!--                  </v-list-item-content>-->
              <!--                </template>-->

              <!--                <v-list-item-->
              <!--                  v-for="child in val.items"-->
              <!--                  :key="child.title"-->
              <!--                  :to="{ name: child.name }"-->
              <!--                  exact-->
              <!--                  class="cursor-pointer bg-hover-light-info ps-8"-->
              <!--                  :class="{ 'bg-light-info': activeSubmenu === child.name }"-->
              <!--                  @click="-->
              <!--                    () => {-->
              <!--                      $router.push({ name: child.name });-->
              <!--                      activeSubmenu = child.name;-->
              <!--                    }-->
              <!--                  "-->
              <!--                >-->
              <!--                  <span-->
              <!--                    class="font-size-lg font-weight-medium text-dark-50 uppercase poppins"-->
              <!--                    :class="{-->
              <!--                      'text-start ps-2': $vuetify.rtl,-->
              <!--                      'text-start ps-2': !$vuetify.rtl,-->
              <!--                    }"-->
              <!--                  >-->
              <!--                    {{ $t(child.title) }}-->
              <!--                  </span>-->
              <!--                </v-list-item>-->
              <!--              </v-list-group>-->
            </template>
          </v-list>

          <v-list v-else>
            <template v-for="group in item.entities">
              <v-list-group :key="group.title" no-action v-if="group?.items">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="$t(group.title)"
                      class="font-size-h5 font-weight-bolder text-dark-50 text-hover-dark uppercase poppins"
                      :class="{ 'text-start': $vuetify.rtl }"
                    />
                  </v-list-item-content>
                </template>

                <!--                <template v-if="group?.items">-->
                <template>
                  <v-list-item
                    v-for="child in group.items"
                    :id="'menu-item-' + child.title"
                    :key="child.title"
                    :to="isAvailableForUser(child) && { name: child.name }"
                    exact
                    class="cursor-pointer text-dark-50 text-hover-dark"
                    :class="{
                      'bg-light-info': activeSubmenu === child.name,
                      'pe-4': $vuetify.rtl,
                      'ps-4': !$vuetify.rtl,
                      'disabled-menu-item': !isAvailableForUser(child),
                      'bg-hover-light-info': isAvailableForUser(child),
                    }"
                    @click="
                      () => {
                        if (isAvailableForUser(child)) {
                          $router.push({ name: child.name });
                          activeSubmenu = child.name;
                        }
                      }
                    "
                  >
                    <!--  plus nav item for unsubscribed users                  style="color: #c5caec !important;"-->
                    <span
                      class="position-relative font-size-lg font-weight-medium uppercase poppins"
                      :class="{
                        'text-start ps-2': $vuetify.rtl,
                        'text-start ps-2': !$vuetify.rtl,
                      }"
                    >
                      {{ $t(child.title) }}

                      <inline-svg
                        v-if="child.premium && isClient"
                        class="position-absolute"
                        style="width: 18px; top: -10px"
                        :src="
                          isAvailableForUser(child)
                            ? '/img/plus/IQ-Plus-star_purple.svg'
                            : '/img/plus/IQ-Core-disabled.svg'
                        "
                      />
                    </span>
                    <b-tooltip
                      v-if="!isAvailableForUser(child)"
                      :target="'menu-item-' + child.title"
                      placement="left"
                      trigger="hover"
                      variant="dark"
                      custom-class="plus-tooltip"
                      boundary="viewport"
                    >
                      <div class="tooltip-content">
                        <div class="text-content">
                          <p class="mb-3">
                            <span v-html="$t('exclusive_to_iq_plus')"></span>
                            <!--                            Unlock it to-->
                            <!--                            streamline<br />your returns process with just one-->
                            <!--                            click.-->
                          </p>
                        </div>
                        <!-- <button class="upgrade-button">Upgrade to Plus</button> -->
                      </div>
                    </b-tooltip>
                  </v-list-item>
                </template>
              </v-list-group>

              <v-list-item
                v-else
                :id="'menu-item-' + group.title"
                :key="group.title"
                :class="{ 'bg-hover-light-info': isAvailableForUser(group) }"
              >
                <div class="position-relative">
                  <router-link
                    :to="isAvailableForUser(group) && { name: group.name }"
                  >
                    <span
                      class="ma-0 pa-0 font-size-h5 font-weight-bolder uppercase poppins"
                      :class="{
                        'text-start ps-2': $vuetify.rtl,
                        'text-dark-50 text-hover-dark':
                          isAvailableForUser(group),
                        'text-dark-25': !isAvailableForUser(group),
                      }"
                    >
                      {{ $t(group.title) }}

                      <inline-svg
                        v-if="group.premium && isClient"
                        class="position-absolute"
                        style="width: 18px; top: -10px"
                        :src="
                          isAvailableForUser(group)
                            ? '/img/plus/IQ-Plus-star_purple.svg'
                            : '/img/plus/IQ-Core-disabled.svg'
                        "
                      />
                    </span>

                    <!--                    <inline-svg-->
                    <!--                      v-if="group.premium && isClient"-->
                    <!--                      class="position-absolute purple-plus-star"-->
                    <!--                      style="width: 16px; top: -6px; right: -14px"-->
                    <!--                      src="/img/plus/plus_star.svg"-->
                    <!--                    />-->
                  </router-link>
                </div>
                <b-tooltip
                  v-if="!isAvailableForUser(group)"
                  :target="'menu-item-' + group.title"
                  placement="left"
                  trigger="hover"
                  variant="dark"
                  custom-class="plus-tooltip"
                  boundary="viewport"
                >
                  <div class="tooltip-content">
                    <div class="text-content">
                      <p class="mb-3">
                        <span v-html="$t('exclusive_to_iq_plus')"></span>
                        <!--                        Unlock it to-->
                        <!--                        streamline your returns process with just one click.-->
                      </p>
                    </div>
                  </div>
                </b-tooltip>
              </v-list-item>

              <!--   No need for submenu type, cos it is for default one and that's in above   -->
              <!--              <v-list-item-->
              <!--                v-else-->
              <!--                :key="group.title"-->
              <!--                :to="{ name: group.name }"-->
              <!--                exact-->
              <!--                class="cursor-pointer bg-hover-light-info"-->
              <!--                :class="{ 'bg-light-info': activeSubmenu === group.name }"-->
              <!--                @click="-->
              <!--                  () => {-->
              <!--                    $router.push({ name: group.name });-->
              <!--                    activeSubmenu = group.name;-->
              <!--                  }-->
              <!--                "-->
              <!--              >-->
              <!--                              <v-list-item-content>-->
              <!--                                <v-list-item-title-->
              <!--                                  v-text="$t(group.title)"-->
              <!--                                  class="font-size-h5 font-weight-bolder text-dark-50 uppercase poppins"-->
              <!--                                  :class="{ 'text-start': $vuetify.rtl }"-->
              <!--                                />-->
              <!--                              </v-list-item-content>-->
              <!--              </v-list-item>-->
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-menu>
    <!-- <SubscriptionPopup
      ref="subscriptionPopup"
      @showSuccessModal="showSuccessModal"
    /> -->
    <!-- <SuccessModal ref="successModal" /> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import SubscriptionPopup from "@/own/components/IqfPlus/SubscriptionPopup.vue";

export default {
  name: "SidebarMain",
  props: ["item"],
  components: {
    // SubscriptionPopup,
  },
  data: () => ({
    activeSubmenu: null,
    showPlusNotification: false,
  }),
  computed: {
    ...mapGetters(["isClient", "isPlusUser"]),

    contentClass: function () {
      const shadow = this.$vuetify.rtl ? "aside-shadow-rtl" : "aside-shadow";
      return `${shadow + " overflow-auto"}`;
    },
    hasPlusAccess() {
      if (this.isClient && this.isPlusUser) {
        return true;
      } else if (this.isClient && !this.isPlusUser) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    isAvailableForUser(child) {
      if (!this.isClient) {
        return true;
      }
      if (this.hasPlusAccess && child.premium) {
        return true;
      }
      if (this.hasPlusAccess && !child.premium) {
        return true;
      }
      if (!this.hasPlusAccess && child.premium) {
        return false;
      }
      if (!this.hasPlusAccess && !child.premium) {
        return true;
      }

      return false;
    },
    // showSuccessModal() {
    //   this.$refs.successModal.toggleModal();
    // },
    // onPressUpgrade() {
    //   this.$refs.subscriptionPopup.toggleModal();
    //   // console.log(".warehouse", value);
    // },
  },
};
</script>

<style></style>
<style scoped lang="scss">
.aside-shadow {
  position: fixed !important;
  top: 0px !important;
  height: 100vh !important;
  inset-inline-start: 70px !important;
  overflow-y: hidden;
  width: 260px;
  z-index: 6;
  /* background-color: transparent; */
  box-shadow: 8px 0 25px -8px rgba(138, 0, 138, 0.4),
    -12px 0 8px -4px rgba(255, 255, 255, 0);
  -webkit-box-shadow: 8px 0 25px -8px rgba(138, 0, 138, 0.4),
    -12px 0 8px -4px rgba(255, 255, 255, 0);
  -moz-box-shadow: 8px 0 25px -8px rgba(138, 0, 138, 0.4),
    -12px 0 8px -4px rgba(255, 255, 255, 0);
}
.aside-shadow-rtl {
  position: fixed !important;
  top: 0px !important;
  height: 100vh !important;
  inset-inline-start: 70px !important;
  overflow-y: hidden;
  width: 260px;
  z-index: 6;
  box-shadow: -2px 0 25px 2px rgba(138, 0, 138, 0.4),
    12px 0 8px 4px rgba(255, 255, 255, 0);
  -webkit-box-shadow: -2px 0 25px 2px rgba(138, 0, 138, 0.4),
    12px 0 8px 4px rgba(255, 255, 255, 0);
  -moz-box-shadow: -2px 0 25px 2px rgba(138, 0, 138, 0.4),
    12px 0 8px 4px rgba(255, 255, 255, 0);
}

.custom-opacity {
  filter: grayscale(100%) opacity(35%);
}
svg {
  width: 100%;
}
.menu-svg {
  z-index: 12;
  width: 28px;
  padding: 13px 0;
  height: auto;
}
.menu-svg:hover,
.menu-svg[aria-expanded="true"] {
  cursor: pointer;
  filter: grayscale(0%) opacity(100%);
}

.purple-plus-star {
  //color: #7e8299 !important;
  //svg {
  fill: #90f;
  //}
}

.light-gray-plus-star {
  //color: #c5caec !important;
  //svg {
  fill: #c5caec;
  //}
}
.disabled-menu-item,
.disabled-menu-item:hover {
  color: #cdd1ef !important;
}
.plus-tooltip .tooltip-inner {
  max-width: none !important; /* Allow content width */
  background: linear-gradient(45deg, #6a11cb, #2575fc); /* Gradient */
  color: white;
  padding: 1rem;
}
.plus-tooltip .tooltip-inner {
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%) !important;
  color: white;
  border-radius: 12px;
  padding: 1.5rem;
  max-width: 420px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.tooltip-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.text-content p {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.4;
  text-align: left;
}

.upgrade-button {
  background: linear-gradient(90deg, #8e2de2 0%, #4a00e0 100%);
  border: none;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s ease;
  text-align: center;
  text-decoration: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.upgrade-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}
</style>
